import { Component, ReactNode } from 'react'

import { isEmpty, NUMBER_PATTERN, OBJECTS_NAMES_PATTERN } from '../../libs/validation/stringRegex'
import { numberValidation } from '../../libs/validation/remoteValidationAbstract'
import { objectsNamesValidation } from '../../libs/validation/remoteValidationAbstract'

import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'

import * as ShipValidation from './ShipValidation'

interface ShipStepTwoProps {
    tipoPolizza: string | undefined
    lunghezza: number | undefined
    peso: number | undefined
    targa: string | undefined
    nome: string | undefined
    porto: string | undefined
    costruttore: string | undefined
    trasportati: number | undefined

    tipoPolizzaError: string | undefined
    lunghezzaError: string | undefined
    pesoError: string | undefined
    targaError: string | undefined
    nomeError: string | undefined
    portoError: string | undefined
    costruttoreError: string | undefined
    trasportatiError: string | undefined

    tipologie: any

    updateTipoCallBack: Function
    updateLunghezzaCallBack: Function
    updatePesoCallBack: Function
    updateTargaCallBack: Function
    updateNomeCallBack: Function
    updatePortoCallBack: Function
    updateCostruttoreCallBack: Function
    updateTrasportatiCallBack: Function
}

class ShipStepTwo extends Component<ShipStepTwoProps> {

    render(): ReactNode {
        return (
            <div className='col-12'>
                <Select
                    id='tipo_assicurazione' name='tipo_assicurazione'
                    label='Oggetto da assicurare' 
                    value={this.props.tipoPolizza}
                    options={this.props.tipologie}
                    callback={this.props.updateTipoCallBack}
                    error={this.props.tipoPolizzaError}
                />
                { (!isEmpty(this.props.tipoPolizza) && this.props.tipoPolizza !== 'soloMotore') &&
                    <>
                        <Input 
                            id="lunghezza" name='lunghezza'
                            label='Lunghezza in metri'
                            value={this.props.lunghezza?.toString()}
                            type='number'
                            step='.1'
                            min='1'
                            regexp={NUMBER_PATTERN}
                            remoteValidation={numberValidation}
                            errorDisplayMsg='Valore non valido'
                            callback={this.props.updateLunghezzaCallBack}
                            error={this.props.lunghezzaError}
                        />

                        <Input 
                            id="peso" name='peso'
                            label='Peso in tonnellate'
                            value={this.props.peso?.toString()}
                            type='number'
                            step='.01'
                            min='0'
                            regexp={NUMBER_PATTERN}
                            remoteValidation={numberValidation}
                            errorDisplayMsg='Valore non valido'
                            callback={this.props.updatePesoCallBack}
                            error={this.props.pesoError}
                        />

                        <Input 
                            id="targa" name='targa'
                            label='Targa'
                            value={this.props.targa}
                            type='string'
                            maxLength={10}
                            remoteValidation={ShipValidation.plateValidation}
                            callback={this.props.updateTargaCallBack}
                            error={this.props.targaError}
                        />

                        <Input 
                            id="nome" name='nome'
                            label='Nome barca'
                            value={this.props.nome}
                            type='string'
                            maxLength={100}
                            regexp={OBJECTS_NAMES_PATTERN}
                            remoteValidation={objectsNamesValidation}
                            callback={this.props.updateNomeCallBack}
                            errorDisplayMsg='Nome non valido'
                            error={this.props.nomeError}
                        />

                        <Input 
                            id="porto" name='porto'
                            label='Porto di stazionamento'
                            value={this.props.porto}
                            type='string'
                            maxLength={100}
                            regexp={OBJECTS_NAMES_PATTERN}
                            remoteValidation={objectsNamesValidation}
                            callback={this.props.updatePortoCallBack}
                            errorDisplayMsg='Nome non valido'
                            error={this.props.portoError}
                        />

                        <Input 
                            id="costruttore" name='costruttore'
                            label='Nome costruttore'
                            value={this.props.costruttore}
                            type='string'
                            maxLength={100}
                            regexp={OBJECTS_NAMES_PATTERN}
                            remoteValidation={objectsNamesValidation}
                            callback={this.props.updateCostruttoreCallBack}
                            errorDisplayMsg='Nome non valido'
                            error={this.props.costruttoreError}
                        />

                        <Input 
                            id="trasportabili" name='trasportabili'
                            label='Numero di trasportati massimo'
                            value={this.props.trasportati?.toString()}
                            type='number'
                            step='1'
                            min='1'
                            regexp={NUMBER_PATTERN}
                            remoteValidation={numberValidation}
                            errorDisplayMsg='Valore non valido'
                            callback={this.props.updateTrasportatiCallBack}
                            error={this.props.trasportatiError}
                        />
                    </>
                }
            </div>
        )
    }
}

export default ShipStepTwo